import StantMultiselect from "../../../utils/stant_multiselect"

$(document).on 'turbolinks:load', ->
  new StantMultiselect('report-excel-analytics-multiselect').add_listener()
  new StantMultiselect('report-excel-analytics-manageable-services-multiselect', true, true).add_listener()